import { render } from "./GasPriceChart.vue?vue&type=template&id=85d7a3da"
import script from "./GasPriceChart.vue?vue&type=script&lang=js"
export * from "./GasPriceChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__